module.exports = __webpack_public_path__ + "static/media/mtf.dc02ed22.jpg";